var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"fa fa-question-circle",attrs:{"role":"button","tabindex":"-1","data-trigger":"focus","data-toggle":"popover","title":_vm.title,"data-content":_vm.content}})}
var staticRenderFns = []

export { render, staticRenderFns }